const caseDocumentTypes = {
    ACTIVITY_FILE: 0,
    EVIDENCE_FILE: 1,
    PRECEDENT_DOCUMENT: 2
}

export default caseDocumentTypes